$(document).ready(function () {
  var $readMoreBlocks = $('[data-read-more-collapse]');

  if ($readMoreBlocks.length && $readMoreBlocks.html()) {
    var totalLength = $readMoreBlocks.html().length;
    var pEndingIndex = $readMoreBlocks.html().lastIndexOf("</p>");


    // This code is wrapping the end text in <p> tag where it is not, and showing the list.
    if (pEndingIndex + 4 < totalLength) {
      var allPText = $readMoreBlocks.html().substr(0, pEndingIndex);
      var extraText = $readMoreBlocks.html().substr(pEndingIndex + 4, totalLength);
      var wrapInP = "<p>" + extraText + "</p>";
      var allText = allPText + wrapInP;
      $readMoreBlocks.html(allText);
    }
  }

  if ($readMoreBlocks.length) {

    var $readLessClick = $('<span>');

    $readMoreBlocks.append(' ', $readLessClick);
    $readLessClick.text('Read Less');
    $readLessClick.addClass('text-link');

    $readLessClick.on('click', function () {
      readMore($readLessClick);
    });


    var readMore = function ($readLessClick) {
      $readMoreBlocks.each(function () {
        var $readMoreBlock = $(this);
        var $paragraphs = $readMoreBlock.find('p');
        var maxChars = 200;
        var $breakpointPara;
        var charCount = 0;
        var thisParaBreakpoint = 0;
        var $readMoreClick = $('<span>');
        var $expandingBlock = $('<span>');
        var $ellipsis = $('<span>');
        var $paraContent = null;
        var $paraHtml = null;
        var before, after;

        $paragraphs.each(function (index, el) {
          var $para = $(el);
          if (charCount < maxChars) {
            $breakpointPara = $para;
            thisParaBreakpoint = maxChars - charCount;
            charCount = charCount + $para.text().length;
          } else {
            $para.hide();
          }
        });

        $paraContent = $breakpointPara.html();

        before = $paraContent.substr(0, thisParaBreakpoint);
        after = $paraContent.substr(thisParaBreakpoint, $paraContent.length - thisParaBreakpoint);

        $breakpointPara.html(before);
        $ellipsis.html('...');
        $breakpointPara.append($ellipsis);
        $breakpointPara.append($expandingBlock);
        $breakpointPara.append($readMoreClick);


        $expandingBlock.html(after);
        $expandingBlock.hide();

        $readMoreClick.on('click', function () {
          $expandingBlock.show();
          $paragraphs.slideDown();
          $readMoreClick.hide();
          $ellipsis.hide();


          $readLessClick.show();

        });

        $readMoreClick.text('Read More');
        $readMoreClick.addClass('text-link');
        $breakpointPara && $breakpointPara.append(' ', $readMoreClick);


        $readLessClick.hide();

      });
    };

    readMore($readLessClick);
  }
});